import { render, staticRenderFns } from "./AxSelect.vue?vue&type=template&id=354508fe&"
import script from "./AxSelect.vue?vue&type=script&lang=js&"
export * from "./AxSelect.vue?vue&type=script&lang=js&"
import style0 from "./AxSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports